import { KeyboardDatePickerProps } from '@material-ui/pickers';
import { useController, UseControllerProps } from 'react-hook-form';
import { KeyboardDatePickerInput } from '.';

type IProps = UseControllerProps & KeyboardDatePickerProps;

export const ControlledDateInput = (props: IProps) => {

  const { field, fieldState } = useController(props);

  return (
    <KeyboardDatePickerInput
      error={fieldState.invalid}
      helperText={fieldState.error && fieldState.error.message}
      {...field}
      {...props}
    />
  );
};